module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "revolutionizetestingAI2.e31dd0c4.png";